<template>
  <div>
    <span class="sr-only" v-if="isAccessibilityEnabled">{{ getAriaText(params) }}</span>
    <span>{{ formattedValue }}</span>
  </div>
</template>

<script>
import { getAriaText } from '@utils/helpers';
export default {
  name: 'default-renderer',
  data() {
    return {
      values: []
    };
  },
  methods: {
    getAriaText,
    refresh(params) {
      this.params = params;
      return false;
    }
  },
  computed: {
    formattedValue() {
      return this.params.valueFormatted ? this.params.valueFormatted : this.params.value;
    },
    isAccessibilityEnabled() {
      return this.$store.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    }
  }
};
</script>
